import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  public openedModal = false
  public openedModalReport = false
  public modalData: any

  public openedModalPlatform = false
  public modalPlatformData: any

  constructor(private dialog: MatDialog) { }

  openModal(component: any, config: MatDialogConfig<any>) {
    this.openedModal = true
    this.openedModalReport = true
    this.modalData = config.data
    return this.dialog.open(component, config);
  }

  closeModal() {
    this.openedModal = false
    this.openedModalReport = false
    this.modalData = null
    this.dialog.closeAll();
  }

  openPlatformModal(data) {
    this.openedModal = true
    this.openedModalPlatform = true
    this.modalPlatformData = data
  }

  closePlatformModal() {
    this.openedModal = false
    this.openedModalPlatform = false
    this.modalPlatformData = null
  }

}
